module.exports = __webpack_public_path__ + "static/media/live.8c5217dd.gif";